const courses =
{
    helmet :
    {
        title : 'Parcours' ,
        metas : []
    }
};

export default courses ;